<template>
	<div style="height: auto;">
		<div class="content">
			<img src="../../assets/pic_price.png" class="top" />
			<div class="price">
				<div>
					<div class="price-base">
						一站式人力协作平台，智灵工助力伙伴轻装上阵
					</div>
					<div class="price_desc">
						选择适合您的版本
					</div>
					<div class="version">
						<div class="version_item">
							<div class="itemP1">
								<div class="item_title">{{versionInfo[0].name}}</div>
								<div class="item_desc">
									零门槛入门，体验人力管理核心价值
								</div>
							</div>
							<div class="item_content">
								<div class="item_day" style="text-align: center;">
									无期限
								</div>
								<div class="item_btn" @click="toBuy(0)">
									立即免费体验
								</div>
								<div class="mt30">
									{{versionInfo[0].name}}包括：
								</div>
								<div class="item_list" v-for="item,key in versionInfo[0].feature_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">{{item.value}}</div>
								</div>
								<div class="item_bottom">
									{{versionInfo[0].desc}}
								</div>
							</div>
						</div>
						
						<div class="version_item">
							<div class="itemP2">
								<div class="item_title">{{versionInfo[1].name}}</div>
								<div class="item_desc">
									智能提效，支撑中小型企业规模化发展
								</div>
							</div>
							<div class="item_content">
								<div>
									￥
									<span class="item_day blueColor">6800.00 </span>
									元/年
								</div>
								<div class="item_btn"  @click="toBuy(1)">
									立即购买
								</div>
								<div class="mt30">
									{{versionInfo[1].name}}所有权益
								</div>
								<div class="item_list" v-for="item,key in versionInfo[1].feature_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">{{item.value}}</div>
								</div>
								<div class="item_bottom">
									{{versionInfo[1].desc}}
								</div>
							</div>
						</div>
						<div class="version_item">
							<div class="itemP3">
								<div class="item_title yellow">{{versionInfo[2].name}}</div>
								<div class="item_desc yellow">
									战略定制，赋能大型企业创新共赢生态
								</div>
							</div>
							<div class="item_content">
								<div>
									<span class="num">
										¥<span class="gradint-text3">29800.00</span>
									</span>
									元/年
								</div>
								<div class="item_btn" @click="toBuy(1)">
									立即购买
								</div>
								<div class="mt30">
									{{versionInfo[2].name}}所有权益
								</div>
								<div class="item_list" v-for="item,key in versionInfo[2].feature_list">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="ml10">{{item.value}}</div>
								</div>
								<div class="item_bottom">
									{{versionInfo[2].desc}}
								</div>
							</div>
						</div>
					</div>
					<div class="versionOne">
						<div class="oneItem">
							<div class="oneTitle">私有化部署</div>
						</div>
						<div class="oneContent">
							<div class="oneLeft">
								<div class="gradint-text">
									详询报价
								</div>
								<div style="margin-top: 16px;font-size: 14px;color: #3d3d3d;">
									安全无忧的私有化部署专属人力资源管理平台
								</div>
								<div class="blue_btn" @click="showMsg">
									报价咨询
								</div>
							</div>
							<div class="oneRight">
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">数据主权完整掌控 - 企业核心人才数据100%存储于自有服务器，杜绝第三方访问风险</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">深度定制，贴合业务 - 告别"一刀切"的SaaS模式，根据企业组织架构、流程制度量身定制</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">性能无忧，稳定可靠 - 独立服务器资源保障系统高速响应，不受公有云平台流量波动影响，关键业务时段永不卡顿</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">灵活扩展，长期投资 - 按需扩容系统能力，一次性投入获得持续使用权，长期使用成本低于订阅模式</div>
								</div>
								<div class="mt14 oneFlex">
									<img src="../../assets/icon_dui.png" class="item_icon"/>
									<div class="selfTitle ml10">专属服务，快速响应 - 资深实施团队部署，7×10小时专属运维支持，问题响应速度提升300%</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="versionFlex">
					<div class="versionItem">
						<div class="flex1 textL">
							版本功能清单
						</div>
						<div class="flex1" v-for="item,key in versionCol">
							{{item.name}}
						</div>
					</div>
					<div v-for="item,index in versionList" :style="!show && index >2 ?'display:none':''">
						<div class="versionItems">
							<div class="itemLeft">
								{{item.title}}
							</div>
						</div>
						<div class="itemTitle" v-for="val,key in item.rows" >
							<div class="flex1 textL">
								{{val.name}}
							</div>
							<div class="flex1" v-for="v,k in versionCol">
								{{val.cells[v.key]}}
							</div>
						</div>
					</div>
				</div>
				<div class="showFlag" @click="changeLable">{{show?'收起对比':'展开对比'}}</div>
				<div class="mt59">
					<div class="server">
						更多版本
					</div>
					<div class="serverFlex" >
						<div :class="(index + 1)%9 == 1?'v1':(index + 1)%9 == 2?'v2':(index + 1)%9 == 3?'v3':(index + 1)%9 == 4?'v4':(index + 1)%9 == 5?'v5':(index + 1)%9 == 6?'v6':(index + 1)%9 == 7?'v7':(index + 1)%9 == 8?'v8':'v9'" v-for="item,index in versionData" >
							<div class="flex">
								<img :src="item.image" class="serveIcon"/>
								<div class="textL ml12">
									<div class="serverTitle">{{item.name}}</div>
								</div>
							</div>
							<div class="serverDesc">
								{{item.content}}
							</div>
							<div class="mt60"></div>
							<div class="priceLeft" v-if="item.price_text">
								<div class="red">{{item.price_text}}</div><div style="transform: translateY(18px);">{{item.period_text}}</div>
							</div>
							<div class="bgBtn" @click="toBuy(1)">去购买</div>
							<!-- <div class="bgBtn" @click="showMsg()" v-else>{{val.btn}}</div> -->
						</div>
					</div>
				</div>
				<div class="mt59">
					<div class="server">
						增值服务
					</div>
					<div class="serverFlex">
						<div class="serveItem" v-for="val,key in serverList">
							<div class="flex">
								<img :src="val.image" class="serveIcon"/>
								<div class="textL ml12">
									<div class="serverTitle">{{val.name}}</div>
								</div>
							</div>
							<div class="serverDesc">
								{{val.content}}
							</div>
							<div class="mt60"></div>
							<div class="priceLeft mt38" v-if="val.price_text">
								<div class="red">{{val.price_text}}</div><div style="transform: translateY(18px);">{{val.period_text}}</div>
							</div>
							<div class="bgBtn" @click="toBuy(2)" >去购买</div>
						</div>
					</div>
				</div>
				<div class="mt59">
					<div class="server">
						常见问题
					</div>
					<div class="qa mt30">
						<div v-for="item,index in list" class="qaItem">
							<div style="margin-right: 5px;" @click="changeShow(index)">{{item.title}}</div>
							<div class="qaDesc mt10" v-if="item.show" >{{item.desc}}</div>
							<img src="../../assets/icon_xia.png" class="qaImg" v-if="item.show"/>
							<img src="../../assets/icon_you.png" class="qaImg" v-else/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//const baseURL = 'https://api.test.laborhub.cn/'; // 测试环境
const baseURL = 'https://api.laborhub.cn/'; // 正式环境
import axios from 'axios';
export default {
	name: 'price',
	props: {
		showPop:false
	},
	data() {
		return {
			list:[
				{'title':'人力资源系统的购买价格包含哪些服务？是否有隐藏费用？','desc':'购买价格主要涵盖组织架构管理、员工档案、薪资计算等基础功能模块，同时包含在线客服、知识库等基础技术支持、管理员操作培训及用户手册；无隐藏费用，但需注意额增值服务，如付款渠道、简历资源、电子合同等高级功能模块，特殊需求的定制开发建议购买前在合同中明确所有费用项。',show:false},
				{'title':'购买前能否申请系统试用？试用期限是多久？','desc':'购买前可通过官网申请或联系销售免费试用，试用期通常为 60 天（部分可享 90 天），试用版仅开放基础模块，高级功能（算薪、发薪等）、数据录入量可能受限，且仅提供基础在线支持、专属顾问服务。',show:false},
				{'title':'系统上手难度如何？员工不懂操作有什么支持渠道？','desc':'系统上手难度较低，员工操作遇困可通过在线视频教程、操作手册与快速指南，后续还可通过工作日 8 小时在线客服、问题知识库获取支持，部分高级版本配备专属客户成功经理。',show:false},
				{'title':'系统后续的升级更新是否免费？升级频率如何？','desc':'系统升级更新政策因部署模式而异，SaaS 模式的订阅费已包含升级服务，安全补丁每月至少一次，功能更新 2-4 周一次，重大更新每季度或半年一次，通常在凌晨自动更新；本地部署系统的小版本 bug 修复多数免费，大版本功能升级一般按原 license 费用的 30% 收费，升级频率由企业自行决定（建议每季度常规维护）。',show:false},
				{'title':'不同版本（标准版 / 高级版）的核心区别是什么？如何选择适配版本？','desc':'标准版与高级版的核心区别体现在功能范围、数据管理、权限控制、风险防控、集成能力及价格上，标准版适合 1-50 人的小微企业；高级版适配 51-200 人的中型企业；200 人以上大型企业建议选择定制服务，选择时需明确核心需求、评估 1-3 年业务发展规模、做好预算规划并通过试用对比体验',show:false},
				{'title':'付款后多久能收到系统使用权限？','desc':'权限开通时间因付费方式与部署模式不同，SaaS 订阅在线支付通常 15 分钟内即时开通，线下付款需款项到账后 1-3 个工作日；本地部署则在合同签订并付款后 5-15 个工作日（含部署时间），管理员权限开通后立即生效。',show:false},
				{'title':'购买系统后如何申请开票？支持开哪种发票（专票 / 普票）？','desc':'发票申请可通过系统后台 “发票管理”提交电子发票申请，填写企业名称等信息后系统自动开具并发送至预留邮箱，纸质发票需联系客户经理或客服提交申请及资料，约 5-10 工作日寄送；系统支持增值税专用发票，发票内容通常为 “技术服务费” 或 “软件服务费”，电子发票与纸质发票具有同等法律效力可随时下载。',show:false},
			],
			show:false,
			versionInfo:[],
			serverList:[],
			versionData:[],
			versionList:[],
		};
	},
	created() {
	  this.httpRequest();
	},
	methods: {
		changeShow(index){
			this.list[index].show = !this.list[index].show;
		},
		toBuy(value){
			if(value == 0){
				var url = 'https://store.laborhub.cn/#/index';
			} else {
				var url = 'https://store.laborhub.cn/#/upgrade?web='+value;
			}
			window.open(url,'_blank');
		},
		showMsg(){
			this.$emit('pop',true);
		},
		async httpRequest() {
			try {
			// 发起 GET 请求
				const response = await axios.get(baseURL+'openapi/price/list',{params: {}});
				this.versionList = response.data.data.price.spGroups;
				this.versionData = response.data.data.more_version;
				this.serverList = response.data.data.zengzhi;
				this.versionCol = response.data.data.price.spCols;
				this.versionInfo = response.data.data.version;
			} catch (error) {
				console.error('请求失败:', error)
			} 
		},
		changeLable(){
			this.show = !this.show;
			if(!this.show){
				document.querySelector(".versionFlex").scrollIntoView({behavior:'smooth',block:'start'});
			}
		}
	}
}
</script>

<style scoped>
@import './index.css';
</style>
